import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiClient from "../../config/AppAdmin";

const initialState = {
  isLoading: false,
  error: null,
  mainCoursesList: [],
};


// Fetch all mainCoursess
export const fetchMainCoursesList = createAsyncThunk(
    "mainCourses/fetchMainCoursesList",
    async (_, { rejectWithValue }) => {
      try {
        const response = await ApiClient.get("/mainCourses");
        // console.log("main courses",response);
        // Check success properly
        if (response.data.success === true) return response.data.data;
        throw new Error("Failed to fetch mainCoursess");
      } catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message);
      }
    }
  );
  

// Delete mainCourses
export const deletemainCourses = createAsyncThunk(
  "mainCourses/deletemainCourses",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.delete(`/mainCourses/${id}`);
      if (response.status === 200) return  id;
      throw new Error("Failed to delete mainCourses");
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  }
);

const mainCoursesSlice = createSlice({
  name: "mainCourses",
  initialState,
  reducers: {
    addmainCourses: (state, action) => {
      state.mainCoursesList.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchMainCoursesList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMainCoursesList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mainCoursesList = action.payload;
      })
      .addCase(fetchMainCoursesList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deletemainCourses.fulfilled, (state, action) => {
        state.mainCoursesList = state.mainCoursesList.filter(
          (d) => d.id !== action.payload
        );
      })
      .addCase(deletemainCourses.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { addmainCourses} = mainCoursesSlice.actions;
export default mainCoursesSlice.reducer;